import { detachKeys } from '~/utils';
import useHandbook from './useHandbook';

type IndustiresType = {
  id?: string | undefined;
  name?: string | undefined;
};

type UseIndustry = {
  codes: IndustiresType[];
  codesDict: Record<string, IndustiresType>;
  getIndustry: (id?: string | number) => string;
  isLoading: boolean;
};

const useIndustry = (): UseIndustry => {
  const { data, isLoading } = useHandbook();
  const codes = data?.industries || [];
  const [codesDict] = detachKeys<IndustiresType>(codes);

  const getIndustry: UseIndustry['getIndustry'] = (id = '') => {
    return codesDict[id]?.name || id.toString();
  };

  return { codes, codesDict, getIndustry, isLoading };
};

export default useIndustry;
